export default __webpack_public_path__ + "static/media/noEarningsIcon.baa178d0.svg";